<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "RewardLadder",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'rewardLadder:add',
        update: 'rewardLadder:update',
        delete: 'rewardLadder:delete',
        deleteBatch: 'rewardLadder:deleteBatch'
      },
      url: {
        get: '/rewardLadder/listByCondition',
        add: '/rewardLadder/add',
        update: '/rewardLadder/update',
        delete: '/rewardLadder/delete/',
        delete_batch: '/rewardLadder/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'level',
        label: '级别',
        show: true,
        width: '',
      }, {
        field: 'quantity',
        label: '数量',
        show: true,
        width: '',
      }, {
        field: 'reward',
        label: '奖励',
        show: true,
        width: '',
      }, {
        field: 'total',
        label: '累计',
        show: true,
        width: '',
      }, {
        field: 'remainNumber',
        label: '领取剩余数量',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '添加滚动公告',
        updateTitle: '修改滚动公告',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'level',
          label: '级别',
          type: 'textarea',
          placeholder: '级别',
          rules: [{message: '请输入级别', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'quantity',
          label: '数量',
          type: 'textarea',
          placeholder: '数量',
          rules: [{message: '请输入数量', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'reward',
          label: '奖励',
          type: 'textarea',
          placeholder: '奖励',
          rules: [{message: '请输入奖励', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'total',
          label: '累计',
          type: 'textarea',
          placeholder: '累计',
          rules: [{message: '请输入累计', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'remainNumber',
          label: '剩余领取数量',
          type: 'textarea',
          placeholder: '剩余领取数量',
          rules: [{message: '请输入剩余领取数量', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
